module.exports = __webpack_public_path__ + "static/img/selected_ok@2x.png";